import { gql } from "@apollo/client";

export const listEngagements = gql`
  query ListEngagements($filter: EngagementFilter!) {
    listEngagements(filter: $filter) {
      total
      items {
        id
        profileId
        performanceDate
        campaignId
        campaignName
        profileEmail
        profilePhone
        profileLogin
        engagementType
        deviceId
        identifier
        productSkus
        programPoints
        campaignPoints
        status
        image
        channel
        vendorName
        channel
        identifier
        productBrand
        campaignShortName
        campaignType
        campaignStatus
        fulfillmentStatus
        rewardStatus
        rewards {
          id
          name
          rewardId
          rewardName
        }
        metadata {
          packageData
          receiptData
          latitude
          longitude
        }
        outcomes {
          outcome
          value
        }
        codeSource
      }
    }
  }
`;
